import React from 'react';

interface ClickAbsorberProps {
  children: React.ReactNode;
  preventDefault?: boolean;
}

/**
 * Component that absorbs clicks and prevents event bubbling
 * Useful when you want to handle click events locally without them propagating to parent elements
 */
export const ClickAbsorber: React.FC<ClickAbsorberProps> = ({
  children,
  preventDefault = true,
}) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    if (preventDefault) {
      e.preventDefault();
    }
  };

  return <div onClick={handleClick}>{children}</div>;
};
